/**
 * Dashboard Navigator - Stack Navigator for Dashboard screens
 * NOW THEME-AWARE
 */

import { createStackNavigator } from '@react-navigation/stack';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardScreen } from '../screens/dashboard/DashboardScreen';
import { RiskScreen } from '../screens/dashboard/RiskScreen';
import { CalibrationScreen } from '../screens/dashboard/CalibrationScreen';
import { useTheme } from '../contexts/ThemeContext';

export type DashboardNavigatorParamList = {
  DashboardHome: undefined;
  Risk: undefined;
  Calibration: undefined;
};

const Stack = createStackNavigator<DashboardNavigatorParamList>();

export function DashboardNavigator() {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const headerStyles = useMemo(
    () => ({
      headerStyle: {
        backgroundColor: theme.colors.surface,
        borderBottomWidth: theme.id === 'bauhaus' ? 2 : 1,
        borderBottomColor: theme.colors.border,
        elevation: 0,
      },
      headerTitleStyle: {
        fontSize: theme.typography.fontSizeLg,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.colors.text,
        textTransform: theme.id === 'bauhaus' ? 'uppercase' : 'none',
        letterSpacing: theme.id === 'bauhaus' ? -0.5 : 0,
      },
      headerTintColor: theme.colors.primary,
    }),
    [theme]
  );

  return (
    <Stack.Navigator screenOptions={{ headerShown: true, ...headerStyles }}>
      <Stack.Screen
        name="DashboardHome"
        component={DashboardScreen}
        options={{ headerShown: false, title: 'Dashboard' }}
      />
      <Stack.Screen name="Risk" component={RiskScreen} options={{ title: t('risk.title') }} />
      <Stack.Screen
        name="Calibration"
        component={CalibrationScreen}
        options={{ title: t('calibration.title') }}
      />
    </Stack.Navigator>
  );
}
